/* ═══════════════════════════════════════════════
   BAP BAP — SHOPIFY THEME JS
═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  // ── NAV: Scroll state ──
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ── NAV: Mobile menu ──
  const mobileToggle = document.getElementById('mobile-toggle');
  const mobileMenu   = document.getElementById('mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('.mobile-link').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── PARTICLES ──
  function spawnParticles(containerId, color1, color2, count = 20) {
    const container = document.getElementById(containerId);
    if (!container) return;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      p.classList.add('particle');
      const size  = Math.random() * 3.5 + 1;
      const x     = Math.random() * 100;
      const dur   = Math.random() * 14 + 8;
      const delay = Math.random() * 12;
      const color = Math.random() > 0.5 ? color1 : color2;
      p.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        left: ${x}%;
        bottom: -10px;
        background: ${color};
        opacity: ${Math.random() * 0.55 + 0.15};
        animation-duration: ${dur}s;
        animation-delay: -${delay}s;
      `;
      container.appendChild(p);
    }
  }

  spawnParticles('herParticles', 'rgba(255,77,184,0.75)', 'rgba(181,0,110,0.5)');
  spawnParticles('hisParticles', 'rgba(0,195,255,0.75)', 'rgba(0,61,181,0.5)');

  // ── CART COUNT update ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      })
      .catch(() => {});
  }
  updateCartCount();

  // ── SCROLL ANIMATIONS ──
  const animateEls = document.querySelectorAll(
    '.col-header, .design-card, .placeholder-card, .manifesto-title, .manifesto-body, .manifesto-btns'
  );
  if ('IntersectionObserver' in window && animateEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animateEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = `opacity 0.7s ${i * 0.08}s ease, transform 0.7s ${i * 0.08}s ease`;
      observer.observe(el);
    });
  }

});

// ── CART: AJAX add to cart + popup ──
document.addEventListener('submit', async (e) => {
  if (!e.target.matches('#product-form')) return;
  e.preventDefault();
  const form = e.target;
  const btn = form.querySelector('.add-to-cart-btn');
  const originalText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  try {
    const formData = new FormData(form);
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    if (response.ok) {
      btn.textContent = '✓ Added!';
      btn.style.background = 'linear-gradient(135deg, #00B577, #003DB5)';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.style.background = '';
      }, 2000);
      const cart = await fetch('/cart.js').then(r => r.json());
      const el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
      showCartPopup(cart);
    } else {
      throw new Error('Failed');
    }
  } catch {
    btn.textContent = 'Try Again';
    btn.disabled = false;
    setTimeout(() => { btn.textContent = originalText; }, 2000);
  }
});

// ── CART POPUP ──
function showCartPopup(cart) {
  document.getElementById('cart-popup')?.remove();
  const last = cart.items[0];
  const popup = document.createElement('div');
  popup.id = 'cart-popup';
  popup.innerHTML = `
    <div id="cart-popup-inner">
      <div id="cart-popup-header">
        <span>✓ Added to Cart</span>
        <button onclick="document.getElementById('cart-popup').remove()" id="cart-popup-close">✕</button>
      </div>
      <div id="cart-popup-item">
        ${last.image ? `<img src="${last.image}" alt="${last.title}" id="cart-popup-img"/>` : ''}
        <div id="cart-popup-info">
          <p id="cart-popup-title">${last.product_title}</p>
          ${last.variant_title !== 'Default Title' ? `<p id="cart-popup-variant">${last.variant_title}</p>` : ''}
          <p id="cart-popup-price">${(last.price / 100).toLocaleString('en-US', {style:'currency', currency:'USD'})}</p>
        </div>
      </div>
      <div id="cart-popup-btns">
        <button onclick="document.getElementById('cart-popup').remove()" class="cart-popup-continue">Continue Shopping</button>
        <a href="/cart" class="cart-popup-checkout">View Cart (${cart.item_count})</a>
      </div>
    </div>
  `;
  document.body.appendChild(popup);
  setTimeout(() => popup.classList.add('cart-popup-visible'), 10);
  setTimeout(() => popup.remove(), 6000);
}

// ── CART: Qty buttons ──
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-qty-btn');
  if (!btn) return;

  const key = btn.dataset.key;
  const action = btn.dataset.action;
  const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
  if (!input) return;

  const currentVal = parseInt(input.value);
  const newVal = action === 'plus' ? currentVal + 1 : Math.max(0, currentVal - 1);
  input.value = newVal;

  document.querySelectorAll('.cart-qty-btn').forEach(b => b.disabled = true);

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newVal })
    });
    const cart = await res.json();

    const countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = cart.item_count;

    if (newVal === 0) {
      document.querySelector(`[data-key="${key}"]`)?.closest('.cart-item')?.remove();
    } else {
      const lineItem = cart.items.find(i => i.key === key);
      if (lineItem) {
        const row = document.querySelector(`[data-key="${key}"]`)?.closest('.cart-item');
        if (row) {
          const priceEl = row.querySelector('.cart-item-total');
          if (priceEl) priceEl.textContent = (lineItem.line_price / 100).toLocaleString('en-US', {style:'currency', currency:'USD'});
        }
      }
    }

    const subtotalEl = document.querySelector('.cart-summary-row:first-child span:last-child');
    if (subtotalEl) subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', {style:'currency', currency:'USD'});

  } catch(e) {
    console.error('Cart update failed', e);
  } finally {
    document.querySelectorAll('.cart-qty-btn').forEach(b => b.disabled = false);
  }
});

// ── CART: Live quantity price update ──
document.querySelectorAll('.cart-qty-input').forEach(input => {
  input.addEventListener('change', async () => {
    const key = input.dataset.key;
    const qty = parseInt(input.value);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      const el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
      window.location.reload();
    } catch(e) {
      console.error('Cart update failed', e);
    }
  });
});